import { create } from 'zustand';
import { adminAPI } from '@/services/api';
import useAuthStore from '@/store/authStore';

// Store Zustand pour gérer le compteur global d'utilisateurs en attente
const usePendingUsersStore = create((set) => ({
  pendingCount: 0,
  isLoading: false,
  lastFetch: null,
  
  setPendingCount: (count) => set({ pendingCount: count }),
  
  fetchPendingCount: async () => {
    set({ isLoading: true });
    try {
      // Vérifier que l'utilisateur est admin ou agent
      const { user } = useAuthStore.getState();
      if (!user || !['ADMIN', 'AGENT'].includes(user.role)) {
        set({ isLoading: false });
        return 0;
      }
      
      const response = await adminAPI.getUserStatistics();
      const stats = response.data;
      
      // Compter les utilisateurs avec statut PENDING
      const pendingCount = stats.by_status?.PENDING || 0;
      
      set({ 
        pendingCount, 
        isLoading: false,
        lastFetch: Date.now()
      });
      
      return pendingCount;
    } catch (error) {
      console.error('Error fetching pending users count:', error);
      set({ isLoading: false });
      return 0;
    }
  },
  
  incrementPendingCount: () => set((state) => ({ 
    pendingCount: state.pendingCount + 1 
  })),
  
  decrementPendingCount: () => set((state) => ({ 
    pendingCount: Math.max(0, state.pendingCount - 1) 
  })),
  
  resetPendingCount: () => set({ pendingCount: 0 }),
}));

// Hook personnalisé pour utiliser le store
export const usePendingUsers = () => {
  const { 
    pendingCount, 
    isLoading, 
    lastFetch,
    fetchPendingCount,
    incrementPendingCount,
    decrementPendingCount,
    resetPendingCount,
    setPendingCount
  } = usePendingUsersStore();

  // Rafraîchir automatiquement si les données sont trop anciennes (> 5 minutes)
  const shouldRefresh = !lastFetch || (Date.now() - lastFetch > 5 * 60 * 1000);

  return {
    pendingCount,
    isLoading,
    fetchPendingCount,
    incrementPendingCount,
    decrementPendingCount,
    resetPendingCount,
    setPendingCount,
    shouldRefresh,
  };
};

export default usePendingUsers;

